<template>
    <v-container fluid class="pt-0">
      <v-card class="pa-2 grey lighten-4 mb-3 card-r pb-2 shadow-1">
        <v-toolbar class="primary  card-r pl-3 text-white">
          <div class="text-xs-left f-20">Denmark Police Details</div>
        </v-toolbar>
      </v-card>
      <!--<v-card class="pa-2 grey lighten-4 mb-3 card-r pb-2 shadow-1">-->

      <v-container fluid grid-list-xl class="pa-0">
        <v-layout row wrap class="Content3 text-xs-center">
          <v-flex v-show="!addnew" lg4 sm6 xs12>
            <v-card class="white shadow-1 card-r mt-3" >
              <v-layout row xs12 justify-center>
                <v-flex xs12 class="pb-0">
                  <v-container fluid grid-list-xl class="pb-0 pt-3 pb-3">
                    <v-layout wrap class="pl-2 pr-2">
                      <v-toolbar class="grey lighten-4 no-shadow mb-3 card-r pl-3 text-white">
                        <div class="text-xs-left text-blue-grey f-20">Add Police Station </div>
                      </v-toolbar>
                    </v-layout>
                    <v-layout wrap class="pl-2 pr-2 pb-5">
                      <v-flex>
                        <v-btn @click="addnew = true" fab large class="primary" dark><v-icon>add</v-icon></v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex v-show="addnew" lg4 sm6 xs12>
            <v-card class="white shadow-1 card-r mt-3" >
              <v-layout row xs12 justify-center>
                <v-flex xs12 class="pb-0">
                  <v-container fluid grid-list-xl class="pb-0 pt-3">
                    <v-layout wrap class="pl-2 pr-2">
                      <v-toolbar class="grey lighten-4 no-shadow mb-3 card-r pl-3 text-white">
                        <div class="text-xs-left text-blue-grey f-20">Add Station </div>
                      </v-toolbar>
                    </v-layout>
                    <v-layout row wrap class="mt-2">
                      <v-flex d-flex xs12 class="pa-0">
                        <v-text-field solo placeholder="station name" v-model="name" :rules="requiredRule" class="pa-0 ma-0" label="Police Station name"></v-text-field>
                      </v-flex>
                      <v-flex d-flex xs12 class=" pa-0">
                        <v-text-field solo
                                      placeholder="55555557"
                                      prefix="+45"
                                      class="pa-0 ma-0" v-model="phone" :rules="requiredRule" label="Phone"></v-text-field>
                      </v-flex>
                      <v-flex d-flex xs12 class=" pa-0">
                        <v-text-field solo
                                      placeholder="enter address" :rules="requiredRule" v-model="address" class="pa-0 ma-0" label="Address">
                        </v-text-field>
                      </v-flex>
                      <v-flex d-flex xs12 class=" pa-0">
                        <v-text-field solo
                                      placeholder="enter mail" v-model="email" :rules="emailRules" class="pa-0 ma-0" label="Email"> </v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-layout>
              <v-flex xs12 class="pt-0 pb-0 ">
                <v-progress-circular
                  indeterminate
                  v-if=loading
                  color="primary"
                ></v-progress-circular>
                <v-alert
                  :value="true"
                  color="success"
                  icon="check_circle"
                  v-if="alert.type=='success'"
                  outline
                >
                  {{alert.msg}}
                </v-alert>
                <v-alert class="pt-3"
                         :value="true"
                         color="error"
                         icon="warning"
                         v-if="alert.type=='warning'"
                         outline
                >
                  {{alert.msg}}
                </v-alert>
              </v-flex>
              <v-flex class="">
                <ConfirmSignup v-bind:value1="name" v-on:confirmyes="AddPolice"/>
              </v-flex>
              <v-flex class="pt-0">
                <v-btn @click="addnew = false" class="ma-0 w-100">close</v-btn>
              </v-flex>
            </v-card>
          </v-flex>
          <v-flex lg4 sm6 xs12 v-for="(n, index) in polices" v-bind:key="index">
            <v-card class="white card-r shadow-1 mt-3" >
              <v-layout row>
                <v-flex xs12>
                  <v-card-title primary-title class="pa-0 pl-4">
                    <div class="text-xs-left">
                      <div class="text-grey-dark f-20" >{{n.name}}</div>
                      <div class="font-weight-regular f-12 ">{{n.address}}</div>
                    </div>
                  </v-card-title>
                </v-flex>

              </v-layout>
              <v-divider light></v-divider>
              <v-card-actions class="">
                <v-list class="w-100">
                  <v-list-tile>
                    <v-list-tile-action class="w-35p">
                      <v-icon color="primary">email</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title class="f-12 font-weight-bold">{{n.email}}</v-list-tile-title>
                      <v-list-tile-sub-title class="f-12 font-weight-bold">Email</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider inset></v-divider>
                  <v-list-tile>
                    <v-list-tile-action class="w-35p">
                      <v-icon color="primary">phone</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title class="f-12 font-weight-bold"> +45 {{n.phone}}</v-list-tile-title>
                      <v-list-tile-sub-title class="f-12 font-weight-bold">Phone</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider inset></v-divider>
                </v-list>
              </v-card-actions>
              <v-card-actions class="pt-0 mt-0">
                <v-spacer></v-spacer>
                <v-btn flat icon class="" color="grey"><v-icon class="">delete</v-icon></v-btn>
                <v-btn flat icon class="" color="grey" :to="'editpolice/'+n.id"><v-icon class="">edit</v-icon></v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>

        </v-layout>
    </v-container>
      <!--</v-card>-->
    </v-container>
</template>

<script>
  /* eslint-disable */
  import ConfirmSignup from "@/components/ConfirmSignup.vue";
  import ConfirmDelete from "@/components/ConfirmDelete.vue";
  import FormData from "form-data";
  import { mapState, dispatch } from "vuex";
  import api from '../../utils/backend-api.js';
  export default {
    data: () => ({
      name: "",
      addnew: false,
      email:"",
      address:"",
      phone:"",
      PolicesList:"",
      emailRules: [
				v => !!v || "E-mail is required",
				v =>
					/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
					"E-mail must be valid"
      ],
      //polices:"",
      requiredRule: [v => !!v || "This field is required"],
      loading:false,
      alert:{
        type:'',
        msg:''
      }

    }),

    methods: {

      AddPolice() {
        // console.log(this.attachment);
        // console.log(this.value)
        this.loading=true
        this.alert.type=""

        var policeDetails = {
          name: this.name,
          phone: this.phone,
          email: this.email,
          address: this.address,

        };


        var formData = new FormData();
        formData.append("name", this.name);
        formData.append("phone", this.phone);
        formData.append("email", this.email);
        formData.append("address",  this.address);


        console.log(formData);
        const config = {
          headers: {
            'content-type': 'multipart/form-data'
          }
        }
        api.postData('driver/createPoliceStation', formData,config).then(res => {
          console.log(res)
          if(res.status==201){
            this.loading=false
            this.alert.type="success"
            this.alert.msg="Police station details created successfully"

            setTimeout(() => {
              this.$router.push("/policemans");
              this.loading=true;
            }, 2200);
          }
        }).catch((error) => {
          console.log(error)
          this.loading=false
          this.alert.type="warning"
          this.alert.msg="Police station is not created. Please check your data & try again"
        })
        // this.$store.dispatch("Modules/AddModule", formData).then(res => {
        //   console.log(res);
        //   this.loading=false
        //   this.alert.type="success"
        //   this.alert.msg="Class Created Successfully"
        //   setTimeout(() => {
        //     this.$router.push("/classes");
        //   }, 1000);
        // }).catch(error=>{
        //   console.log(error)
        //   this.loading=false
        //   this.alert.type="warning"
        //   this.alert.msg="Class not created"
        // });
      }

      //
    },

    beforeCreate:function() {
      console.log("created")
      Store.commit("setLoading", { loading: true });
      Store.dispatch("police/getAllPolices")
      console.log("okkkkk")
      // .then(res => {
      //   this.PolicesList = res;
      //   Store.commit("setLoading", { loading: false });
      // })
      // .catch(() => {
      //   Store.commit("setLoading", { loading: false });
      // });
      console.log(this.polices)
  },

      deletePolice: function(id){
      console.log("before delete")
      Store.commit("setLoading", { loading: true });
      Store.dispatch("police/deletePoliceById")
      console.log("deleted")
      // .then(res => {
      //   this.PolicesList = res;
      //   Store.commit("setLoading", { loading: false });
      // })
      // .catch(() => {
      //   Store.commit("setLoading", { loading: false });
      // });
      console.log(this.polices)
  },

    computed: {
    ...mapState({
      //polices:"polices",
      polices: Polices => Store.state.police.polices
    })
  },

    components: {
      ConfirmDelete,
      ConfirmSignup,

    }


  }

</script>
<style>

  .v-dialog{
    box-shadow: none!important;
  }
  .btn-customer{
    margin: 6px 0px 6px 0px !important;
    height: 45px;
    width: 100%;
  }
  .text-white{
    color: #ffffff!important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/pages/PoliceMans.vue